export default {
    methods: {
        isRequiredFieldsFilled(fields) {
            return !fields.filter(f => f.is_required && !f.value).length
        }
    }
}
